import { createContext } from "react"

export interface CreationOverlayPublicContextValue {
  openCreationOverlay: (time?: string) => void;
}

type ContextType = CreationOverlayPublicContextValue | null
export const CreationOverlayPublicContext = createContext<ContextType>(null)
